import React from 'react';

export default function AdminTwilioSection({ appId }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>📱</span>
          <span>Twilio</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          SMS, voice, WhatsApp and other programmable communications
        </p>
      </div>

      <div className="space-y-4">
        <div className="p-4 bg-gray-50 border border-gray-200 rounded-lg">
          <p className="text-sm text-gray-700 mb-3">
            Send SMS, make and receive voice calls, use WhatsApp Business API, and more. Common use cases include verification codes, order updates, appointment reminders, and automated phone flows.
          </p>
          <p className="text-xs text-gray-600 mb-4">
            Twilio is available for this organisation. Use the console to manage phone numbers, messaging services, and API credentials.
          </p>
          <a
            href="https://console.twilio.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-zapt-purple rounded-lg hover:bg-zapt-purple/90 transition-colors"
          >
            Open Twilio Console →
          </a>
        </div>
      </div>
    </div>
  );
}
